<template>
  <div>
    <el-button type="primary" size="small" icon="el-icon-back" @click="onBack()">返回</el-button>
    <el-form :inline="true" :model="query" class="query-form" size="small">
      <el-form-item>
        <el-date-picker
          v-model="createTime"
          type="datetimerange"
          :picker-options="pickerOptions"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="left"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          @change="dateChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item class="query-form-item">
        <el-select
          v-model="query.content"
          placeholder="获得/使用方式"
          @change="onSubmit"
          style="width:150px"
          clearable
        >
          <el-option label="不限" value="-1"></el-option>
          <el-option
            v-for="(item, index) in IntegralNoteList"
            :key="index"
            :label="item.integralnote"
            :value="item.integralnote"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        <el-button type="primary" icon="el-icon-edit" @click.native="handleForm(null, null)">发放积分</el-button>
      </el-form-item>
    </el-form>
    <!-- 显示表单 -->
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="detailList"
      :header-cell-style="{ background: '#F4F4F5', color: '#606266' }"
      @selection-change="handleSelectionChange"
      border
    >
      <el-table-column type="selection" width="50" fixed/>
      <el-table-column label="获得/使用方式" prop="integralnote" align="center"/>
      <el-table-column label="积分数" align="center">
        <template slot-scope="scope">
          <!-- <span v-if="scope.row.integraltype==1">+</span>
          <span v-if="scope.row.integraltype==0">- </span>-->
          <span v-if="scope.row.integral != null">
            {{
            scope.row.integral
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="获得/使用时间" prop="lineaddtime" align="center">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span v-if="scope.row.lineaddtime != null">
            {{
            scope.row.lineaddtime | formatDateStr("yyyy-MM-dd hh:mm:ss")
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="244" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click.native="handleDel(scope.row.integralid)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="left-container">
      <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
      <transition name="el-fade-in-linear">
        <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
      </transition>
    </div>
    <el-pagination
      class="pagination-container"
      background
      :page-size="query.pageSize"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total,sizes,prev, pager, next, jumper"
      :page-sizes="[10, 20, 30, 50]"
      :total="totalNumber"
    ></el-pagination>
    <!-- </el-scrollbar> -->
    <!--表单-->
    <el-dialog
      title="发放积分"
      :visible.sync="formVisible"
      :before-close="hideForm"
      width="30%"
      v-dialogDrag
    >
      <el-form
        :model="formData"
        ref="dataForm"
        :label-position="labelPosition"
        :rules="integralRule"
      >
        <el-form-item class="query-form-item" label="积分" prop="integral">
          <el-input v-model="formData.integral" maxlength="9" placeholder="请输入积分" clearable></el-input>
        </el-form-item>
        <el-form-item class="query-form-item" label="备注" prop="integralnote">
          <!-- <el-input
            v-model="formData.integralnote"
            placeholder="请输入备注(最多输入6个字符)"
            :maxlength="6"
            clearable
          ></el-input>-->
          <textarea
            v-model="formData.integralnote"
            class="site"
            maxlength="6"
            @input="descInput"
            placeholder="最多输入6个字"
            :rows="1"
            style="width:100%;height:70px"
          ></textarea>
          <span class="xianzhi">{{ remnant }}/6</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="hideForm">取消</el-button>
        <el-button type="primary" @click.native="formSubmit(userid)" :loading="formLoading">确定</el-button>
      </div>
    </el-dialog>
    <!--查看弹框-->
  </div>
</template>

<script>
import {
    getMbIntegral,
    getIntegralNote,
    deleteUserIntegral,
    addIntegral
} from "../../api/mbUser/mbUser";
const formJson = {
    usernick: "",
    userpass: "",
    userid: ""
};
export default {
    data() {
        var integralTest = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入积分"));
            } else {
                var reg = /^[1-9]\d*$/;
                if (reg.test(value)) {
                    callback();
                } else {
                    return callback(new Error("请输入整数"));
                }
            }
        };
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近六个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 180
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            remnant: 0,
            labelPosition: "right",
            isrelogin: "",
            cancelToggle: false,
            createTime: [],
            query: {
                startTime: "",
                endTime: "",
                content: "",
                currentPage: 1,
                pageSize: 10,
                userid: ""
            },
            list: [],
            IntegralNoteList: [],
            detailList: [],
            spanArr: [],
            selectedOptions: [],
            totalNumber: 0,
            loading: true,
            index: null,
            formName: null,
            formMap: {
                add: "添加",
                edit: "编辑",
                detail: "详情"
            },
            integralRule: {
                integral: [
                    {
                        required: true,
                        message: "请输入积分",
                        trigger: "blur"
                    },
                    { validator: integralTest, trigger: "blur" }
                ],
                integralnote: {
                    required: true,
                    message: "请输入备注",
                    trigger: "blur"
                }
            },
            formLoading: false,
            formVisible: false,
            detailVisible: false,
            formData: formJson,
            multipleSelection: [] //多选集合,
        };
    },
    methods: {
        //备注限制字数
        descInput() {
            var txtVal = this.formData.integralnote.length;
            this.remnant = 6 - txtVal;
        },
        onBack() {
            //返回上一页
            this.$router.go(-1);
        },
        getIntegralNote() {
            getIntegralNote(this.query)
                .then(response => {
                    this.IntegralNoteList = response.data || [];
                })
                .catch(() => {});
        },

        getMbIntegral() {
            this.loading = true;
            getMbIntegral(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.detailList = response.data.list || [];
                    this.totalNumber = response.data.totalNumber || 0;
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                })
                .catch(() => {
                    this.loading = false;
                    this.detailList = [];
                    this.totalNumber = 0;
                });
        },

        dateChange(val) {
            if (val == null) {
                this.query.startTime = "";
                this.query.endTime = "";
            } else {
                this.query.startTime = val[0];
                this.query.endTime = val[1];
            }
            this.getMbIntegral();
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                    if (row.userid == this.query.userid) {
                        return true;
                    } else {
                        return false;
                    }
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (val == "") {
                this.cancelToggle = false;
                return;
            }
            this.cancelToggle = true;
        },
        delGroup() {
            var ids = this.multipleSelection
                .map(item => item.integralid)
                .join(); //获取所有选中行的id组成的字符串，以逗号分隔
            if (ids == "") {
                this.$message({
                    message: "请先选择",
                    type: "warning"
                });
                return;
            }
            this.handleDel(ids);
        },
        onRest() {
            Object.assign(this.query, this.$options.data().query)
            this.createTime=[]
            this.query.userid=this.userid
            this.getMbIntegral();
        },
        onSubmit() {
            this.getMbIntegral();
        },

        handleCurrentChange(val) {
            this.query.currentPage = val;
            //scrollTo(0, 800);
            this.getMbIntegral();
        },
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.getMbIntegral();
        },

        // 隐藏表单
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            return true;
        },
        // 隐藏详情弹框
        hideDetailForm() {
            // 更改值
            this.detailVisible = !this.detailVisible;
            return true;
        },
        // 显示表单
        handleForm(index, row) {
            this.formVisible = true;
            this.formData = Object.assign({}, formJson);
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            this.formName = "add";
        },
        // 删除
        handleDel(ids) {
            if (ids) {
                this.$confirm("确认要删除吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        this.loading = true;
                        var params = new URLSearchParams();
                        params.append("ids", ids);
                        deleteUserIntegral(params)
                            .then(response => {
                                this.loading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("删除成功");
                                // 刷新数据
                                //this.list.splice(index, 1);
                                this.getMbIntegral();
                            })
                            .catch(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        },
        addGroup() {
            var ids = this.multipleSelection.map(item => item.userid).join(); //获取所有选中行的id组成的字符串，以逗号分隔
            if (ids == "") {
                this.$message({
                    message: "请先选择",
                    type: "warning"
                });
                return;
            }
            this.formSubmit(ids);
        },
        formSubmit(userid) {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.formData.userid = userid;
                    var params = this.formData;//new URLSearchParams(this.formData);

                    addIntegral(params)
                        .then(response => {
                            this.loading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("添加成功");
                            this.formVisible = false;
                            // 刷新数据
                            this.getMbIntegral();
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        }
    },

    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.pageSize = parseInt(this.query.pageSize);
        // 加载表格数据

        this.userid = this.$route.query.userid;
        this.getMbIntegral();
        this.getIntegralNote();
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
